import React, {useEffect, useState} from "react";
import {SSO_CODE, DASHBOARD_BFF_LOGIN,DASHBOARD_BFF_CHANGE_PASSWORD_API,DASHBOARD_BFF_SSO_LOGIN,APP_SECURITY_TOKEN ,ENV} from '../utils/api';
import {routesPaths} from "../routing/routesPaths";
import { Spin } from "antd";
import zurich_logo from "../images/png/logo_cdp_big.png";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import "./LoginPage.scss";
import Cookies from 'js-cookie';



const LoginPage = (props) => {
    const {t} = props;
    const {code} = props;
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [otp, setOtp] = useState(null);
    const [newPassword, setNewPassword] = useState(null);
    const [repeatPassword, setRepeatPassword] = useState(null);
    const [setUpPassword , setSetUpPassword] = useState(false);
    const { v4: uuidv4 } = require('uuid');

    const loginData = {
        username: username,
        password: password,
        otp : otp
    };

    useEffect(() => {
        if(ENV !== "LOCAL"){
            if(ENV !== "DEV"){
                ssoLogin();
            }
        }else{
            if(ENV !== "DEV"){
                sessionStorage.setItem("enabledModules", "SDD,SCT,SIGNATURE,SIGNATURE_USERS,SIGNATURE_PROFILES,STATISTICS,CONFIGURATION");
                sessionStorage.setItem("enabledFunctions", "0700,0701,0702,0703,0704,0705,0706,0707,0708,0709,0710,0801,0802,0803,0804,0805,0806,0807,0808,0809,0810,0811,0812,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110");
                sessionStorage.setItem("username", "developer");
                sessionStorage.setItem("email", "developer@nttdata.com");
                sessionStorage.setItem("appId", "IT00002001_DEV");
                sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);

                if (ENV === "DEV" || ENV === "LOCAL") {
                    Cookies.set('authToken', "xxx", { expires: 7, path: '/' });
                }
                
                window.location.replace(routesPaths.paymentHub);
            }
        }
    }, [])

    async function ssoLogin(){
        setLoading(true);

        const redirectUri = `${window.location.origin}/demetra`;
        const encodedRedirectUri = encodeURIComponent(redirectUri);

        if(code != null){
            let data = JSON.stringify({"code": code});

            let config = {
                method: 'post',
                url: DASHBOARD_BFF_SSO_LOGIN,
                headers: { 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'X-Application-Token' : APP_SECURITY_TOKEN
                },
                params:{
                    owner: "CDP"
                },
                data : data
            };

            axios.request(config).then((response) => {
                sessionStorage.setItem("username",response.data.username);
                sessionStorage.setItem("email",response.data.email);
                sessionStorage.setItem("enabledModules",response.data.modulesEnabled);
                sessionStorage.setItem("enabledFunctions",response.data.functionsEnabled);
                sessionStorage.setItem("appId", response.data.appId);
                sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);
                window.location.replace(routesPaths.paymentHub);
                setLoading(false);
            }).catch((error) => {
                console.log(error.toString());
                setLoading(false);
                sessionStorage.clear();
                window.location = SSO_CODE.replace("REPLACE_IT", uuidv4()) + "&nonce=" + uuidv4() + "&prompt=select_account" + "&redirect_uri=" + encodedRedirectUri;
            });
        }else{
            sessionStorage.clear();
            window.location = SSO_CODE.replace("REPLACE_IT", uuidv4()) + "&nonce=" + uuidv4() + "&prompt=select_account" + "&redirect_uri=" + encodedRedirectUri;
            setLoading(false);
        }
    }

    function handleFormInputs(e, id) {
        if (id === "username") {
            setUsername(e.target.value);
        }
        if (id === "password") {
            setPassword(e.target.value);
        }
        if(id === "otp"){
            setOtp(e.target.value);
        }
        if (id === "newPassword") {
            setNewPassword(e.target.value);
        }
        if (id === "repeatPassword") {
            setRepeatPassword(e.target.value);
        }
    }
    
    function handleEnterKeyPress(event) {
        if (event.key === "Enter") {
            loginAuth();
        }
    }

    async function loginAuth() {
        setLoading(true);
        if ( !username || !password || !otp ) {
            alert(t("error.fillInLoginFormFirst", {ns: "messages"}));
        } else {
            await axios({
                url: DASHBOARD_BFF_LOGIN,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Application-Token": APP_SECURITY_TOKEN 
                },
                data: JSON.stringify(loginData)
            }).then((response) => {
                sessionStorage.setItem("enabledModules", response.data.modulesEnabled);
                sessionStorage.setItem("enabledFunctions", response.data.functionsEnabled);
                sessionStorage.setItem("username", response.data.username);
                sessionStorage.setItem("email", response.data.email);
                sessionStorage.setItem("appId", response.data.appId);
                sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);

                if (ENV === "DEV" || ENV === "LOCAL") {
                    Cookies.set('authToken', response.data.access_token, { expires: 7, path: '/' });
                }

                window.location.replace(routesPaths.paymentHub);
            }).catch((error) => {
                console.log(error.response.status);
                console.log(error.response.data.messages[0].message);
                if(error.response.data.messages[0].message === "Account is not fully set up" && error.response.status === 400){
                    alert("Please set your password");
                    setOtp(null);
                    setSetUpPassword(true);
                }else{
                    const s401 = error.response && error.response.status === 401 && 401;
                    if (s401) {
                        alert("Auth failed");
                    } else {
                        alert("Service unavailable" + ": " + error.response);
                    }
                }
            })
        }
        setLoading(false);
    }

    function setUpNewPassword(){
        if(newPassword === repeatPassword){
            setLoading(true);
            var axios = require('axios');

            const encodedOldPassword = Buffer.from(password).toString('base64');
            const encodedPassword = Buffer.from(newPassword).toString('base64');

            var config = {
              method: 'PUT',
              url: `${DASHBOARD_BFF_CHANGE_PASSWORD_API}?username=${username}&oldPassword=${encodedOldPassword}&password=${encodedPassword}&otp=${otp}`,
              headers: { 
                'accept': 'application/json',
                'X-Application-Token' : APP_SECURITY_TOKEN
              }
            };
            
            axios(config).then(function (response) {
              setSetUpPassword(false);
              alert("Password update success");
              setLoading(false);
            }).catch(function (error) {
              console.log(error);
              setLoading(false);
            });
        }else{
            alert("You have entered different passwords!");
        }
    }
    
    return (
        <div>
            { ENV !== "DEV" &&
                <Spin spinning={loading} tip={"loading"}/>
            }
            { ENV === "DEV" &&
                <div className="login-page" style={{borderRadius: "5px",backgroundColor:"#3e5364"}}>
                    <div className="login-page_form-container" style={{backgroundColor:"white"}}>
                        <img width="350px" height="164px" src={zurich_logo} alt="zurich-logo"/>
                        {!setUpPassword && 
                            <Grid container
                                style={{marginTop: "20px",backgroundColor: "#FFFFFF",borderRadius : "5px",paddingRight: "7px",paddingBottom:"8px"}}
                                spacing={1} 
                                direction="column" 
                                justifyContent="space-between" 
                                alignItems="center"
                            >
                                <Grid container item xs={12}>
                                    <TextField fullWidth id="outlined" label="Username" variant="outlined" onChange={(e) => handleFormInputs(e, "username")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth
                                        type="password"
                                        id="outlined-password-input"
                                        label="Password"
                                        variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "password")}
                                        onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth
                                        type="password"
                                        id="outlined-password-input"
                                        label="otp"
                                        variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "otp")}
                                        onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <Button variant="contained"
                                        style={{backgroundColor:"#FFBB4D", color: "#323234",fontSize: "14px",letterSpacing: "1px"}}
                                        loading={loading.toString()}
                                        onClick={loginAuth}
                                        fullWidth>
                                            <b>LOGIN</b>
                                    </Button>
                                </Grid>
                            </Grid>
                        }{setUpPassword && 
                            <Grid container
                                style={{marginTop: "20px",
                                        backgroundColor: "#FFFFFF", 
                                        borderRadius : "5px", 
                                        paddingRight: "7px", 
                                        paddingBottom:"8px"
                                    }}
                                spacing={1} 
                                direction="column" 
                                justifyContent="space-between" 
                                alignItems="center"
                            >
                                <Grid container item xs={12}>
                                        <TextField fullWidth type="password" id="outlined-password-input" label="Password" variant="outlined"
                                            onChange={(e) => handleFormInputs(e, "newPassword")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth type="password" id="outlined-password-input" label="Repeat Password" variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "repeatPassword")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth type="password" id="outlined-password-input" label="otp"
                                        variant="outlined" onChange={(e) => handleFormInputs(e, "otp")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <Button variant="contained" loading={loading.toString()} onClick={setUpNewPassword} fullWidth
                                        style={{backgroundColor:"#FFBB4D", color: "#323234",fontSize: "14px",letterSpacing: "1px"}}
                                    >
                                        <b>Set Up Password</b>
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            }
        </div>
    )
};

export default LoginPage;